export default __webpack_public_path__ + "static/media/FolderSimple.0b3f9881.svg";